<div id="swipeContainer">
	<ul id="studyReport" *ngIf="studyReport != null">
		<li class="current">
			<div style="position: absolute;top: 4rem;left: 3.6rem;"><span class="boldYellow" style="margin-left: 0;">{{studyReport.latestDate}}</span> <br/>这一天的</div>
			<div style="position: absolute;top: 5.4rem;left: 3.6rem;"><span class="boldYellow" style="margin-left: 0;">{{studyReport.latestTime}}</span><br/>你好像特别的努力。</div>
		</li>
		<li class="next">
			<div style="position: absolute;top: 0.7rem;left: 1rem;">
				<br/>你在<span class="boldYellow2">{{studyReport.exerciseName}}</span> 当中，<br/>
				一共获得了<span class="boldYellow">{{studyReport.maxExerciseStar}}颗</span>星星，<br/>
				你可真是个小机灵鬼。
			</div>
		</li>
		<li>
			<div style="position: absolute;top: 2.9rem;left: 1.4rem;">
				<span class="boldYellow" style="margin-left: 0;">{{studyReport.maxLoginDay}}</span> 这一天，<br/>
				你进入英跃<span class="boldYellow">{{studyReport.maxLoginCount}}次</span>，<br/>
				平均<span class="boldYellow">{{studyReport.loginTimeInterval}}</span>进入一次，<br/>
				你有一颗蠢蠢欲动想要学习的心。
			</div>
		</li>
		<li>
			<div *ngIf="!(studyReport.maxApptaskStar == 3 && studyReport.maxApptaskStarMinCount == 1) && studyReport.maxApptaskStar != 0 " style="position: absolute;top: 1.2rem;left: 1.4rem;">
				在<span class="boldYellow2">{{studyReport.apptaskName}}</span>当中，你经过<br/>
				<span class="boldYellow">{{studyReport.maxApptaskStarMinCount}}次努力</span> <br/>
				<div *ngIf="studyReport.maxApptaskStar == 3">终于得到了三星，<br/>
				努力总有收获。</div>
				<div *ngIf="studyReport.maxApptaskStar != 3">还是只获得{{studyReport.maxApptaskStar}}星，<br/>
				人生就是这样。</div>
			</div>
			<div *ngIf="studyReport.maxApptaskStar == 3 && studyReport.maxApptaskStarMinCount == 1 " style="position: absolute;top: 1.2rem;left: 1.4rem;">
				在<span class="boldYellow2">{{studyReport.apptaskName}}</span>当中，<br/>
				你一气呵成，<br/>
				仅1次尝试就得到了三星。<br/>
			</div>
			<div *ngIf="studyReport.maxApptaskStar == 0"   style="position: absolute;top: 1.2rem;left: 1.4rem;">
				该配合练习的你却装作视而不见，<br/>闯关任务{{studyReport.maxApptaskStarMinCount}}次努力，<br/>让你轻松“躺赢”，哦不，是躺平。
			</div>
		</li>
		<li>
			<div style="position: absolute;top:1.2rem;left: 1.4rem;">
				在过去的三个月当中,<br/>
				你为你的领导力投资了,<br/>
				<span class="boldYellow" style="margin-left: 0;">{{studyReport.loginTimeCount}}分钟</span>。
			</div>
		</li>
	</ul>
	<div id="swiperArrow" class="arrow"></div>
	<div id="swiperCloser" (click)="CloseSwiper()"  class="closer">关闭</div>
</div>


// WEBPACK FOOTER //
// ./src/component/swiper/component.swiper.html